import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { DropdownItem } from 'components/shared/DesignSystem/Dropdown';

const TypeCardContainer = styled.div`
  display: flex;
  gap: var(--cc_size_spacing_s);
  align-items: center;
  text-align: left;
`;

const TaskTypeIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cc_size_spacing_s);

  i {
    font-size: var(--cc_size_text_m);
  }
`;

const TypeDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_xxs);
`;

const TaskTypeTitle = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: var(--cc_size_text_s);
`;

const TaskTypeDescription = styled.p`
  margin: 0;
  color: var(--cc_color_text_subtle);
  font-weight: 400;
  font-size: var(--cc_size_text_xs);
`;

const TaskTypeCard = ({
  type,
  title,
  subtitle,
  iconName,
  handleOnCardPress,
}) => {
  return (
    <DropdownItem onClick={() => handleOnCardPress(type)}>
      <TypeCardContainer>
        <TaskTypeIcon>
          <i className={`mdi mdi-${iconName}`} />
        </TaskTypeIcon>
        <TypeDescriptionContainer>
          <TaskTypeTitle>{title}</TaskTypeTitle>
          <TaskTypeDescription>{subtitle}</TaskTypeDescription>
        </TypeDescriptionContainer>
      </TypeCardContainer>
    </DropdownItem>
  );
};

TaskTypeCard.propTypes = {
  handleOnCardPress: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default TaskTypeCard;
